import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IconComponent } from '@frontendlib/components/components/icon/icon.component';
import { LinkComponent } from '@frontendlib/components/components/link/link.component';

/**
 * Marketing call-to-action shown on public shared (read-only) pages, inviting anonymous
 * viewers to get their own knots and tags on Stitch.ai (links to the app root).
 */
@Component({
  selector: 'app-shared-signup-cta',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, LinkComponent],
  templateUrl: './shared-signup-cta.component.html',
})
export class SharedSignupCtaComponent {}
